import { Controller } from "@hotwired/stimulus"

// Queues a dashboard tile's query (POST) once the page can receive its result: this placeholder is on the page
// (the result is broadcast to it) AND the page's results stream is subscribed (turbo-cable-stream-source sets
// `connected` on the server's confirmation) — so a fast result can't arrive before there's anywhere for it to
// land. A placeholder replaced first (a newer filter change) never queues.
export default class extends Controller {
  // `source`: the id of the page's results stream (a dashboard's, or an analytics page's panels stream)
  static values = { url: String, source: { type: String, default: "dashboard-results-stream" } }

  connect() {
    const source = document.getElementById(this.sourceValue)
    if (!source || source.hasAttribute("connected")) return this.enqueue()

    this.observer = new MutationObserver(() => {
      if (!source.hasAttribute("connected")) return
      this.disconnect()
      this.enqueue()
    })
    this.observer.observe(source, { attributes: true, attributeFilter: ["connected"] })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  enqueue() {
    fetch(this.urlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content },
    })
  }
}
